/* =========================================================================
   BVX-UI - Becquet Voiture
   1. Carrousels produits : fleches, pagination, clavier (le defilement lui
      meme est 100 % CSS via scroll-snap ; ce script ne fait que piloter).
   2. En-tete : nom accessible de la recherche et des boutons panier/compte.
   3. Pastille du panier : masquee quand le compte vaut 0 (le CSS ne peut pas
      tester le contenu textuel, et une regle Liquid figee au chargement
      empecherait la pastille de reapparaitre apres un ajout en AJAX).
   4. Page produit : badge d'economie calcule a partir des prix REELLEMENT
      affiches (aucun prix invente), recalcule a chaque changement de variante.
   Aucune dependance externe.
   ========================================================================= */
(function () {
  'use strict';
  if (window.bvxUiInit) return;
  window.bvxUiInit = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ----------------------------------------------------------------------
     1. CARROUSELS
     ---------------------------------------------------------------------- */
  function pagesOf(track) {
    var max = track.scrollWidth - track.clientWidth;
    if (max <= 2) return 1;
    return Math.ceil(max / track.clientWidth) + 1;
  }

  function initSlider(root) {
    if (root.dataset.bvxPsReady === '1') return;
    root.dataset.bvxPsReady = '1';

    var track = root.querySelector('[data-bvx-ps-track]');
    var prev = root.querySelector('[data-bvx-ps-prev]');
    var next = root.querySelector('[data-bvx-ps-next]');
    var dotsBox = root.querySelector('[data-bvx-ps-dots]');
    if (!track) return;

    function step() { return Math.max(120, track.clientWidth * 0.92); }

    function scrollBy(dir) {
      track.scrollTo({
        left: track.scrollLeft + dir * step(),
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
    }

    function buildDots() {
      if (!dotsBox) return;
      var n = pagesOf(track);
      if (n <= 1) { if (dotsBox.childElementCount) dotsBox.textContent = ''; return; }
      if (dotsBox.childElementCount === n) return;
      dotsBox.textContent = '';
      for (var i = 0; i < n; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'bvx-ps__dot';
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        b.setAttribute('aria-label', bvnG('page_of', 'Aller a la page {i} sur {n}', { i: i + 1, n: n }));
        b.dataset.index = String(i);
        dotsBox.appendChild(b);
      }
    }

    function sync() {
      var max = track.scrollWidth - track.clientWidth;
      var atStart = track.scrollLeft <= 2;
      var atEnd = track.scrollLeft >= max - 2;
      if (prev) { prev.disabled = atStart; prev.hidden = max <= 2; }
      if (next) { next.disabled = atEnd; next.hidden = max <= 2; }
      if (dotsBox && dotsBox.childElementCount) {
        var n = dotsBox.childElementCount;
        var idx = max <= 0 ? 0 : Math.round((track.scrollLeft / max) * (n - 1));
        for (var i = 0; i < n; i++) {
          dotsBox.children[i].setAttribute('aria-selected', i === idx ? 'true' : 'false');
        }
      }
    }

    if (prev) prev.addEventListener('click', function () { scrollBy(-1); });
    if (next) next.addEventListener('click', function () { scrollBy(1); });
    if (dotsBox) {
      dotsBox.addEventListener('click', function (e) {
        var d = e.target && e.target.closest ? e.target.closest('.bvx-ps__dot') : null;
        if (!d) return;
        var n = dotsBox.childElementCount;
        var max = track.scrollWidth - track.clientWidth;
        var i = parseInt(d.dataset.index, 10) || 0;
        track.scrollTo({
          left: n > 1 ? (max * i) / (n - 1) : 0,
          behavior: reduceMotion ? 'auto' : 'smooth'
        });
      });
    }

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); scrollBy(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); scrollBy(-1); }
    });

    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; sync(); });
    }, { passive: true });

    function refresh() { buildDots(); sync(); }
    refresh();
    // les images sont en lazyload : la largeur bouge apres leur arrivee
    setTimeout(refresh, 400);
    setTimeout(refresh, 1600);
    if (window.ResizeObserver) {
      new ResizeObserver(function () { refresh(); }).observe(track);
    } else {
      window.addEventListener('resize', refresh);
    }
  }

  function initAllSliders(scope) {
    (scope || document).querySelectorAll('[data-bvx-ps]').forEach(initSlider);
  }

  /* ----------------------------------------------------------------------
     2. EN-TETE : accessibilite de la recherche et des boutons
     Le gabarit d'origine rend la loupe sous forme de <span> (donc pas de nom
     accessible, pas de tabulation) et les liens panier / compte n'ont qu'un
     attribut title. On corrige sans toucher a sections/header.liquid.
     ---------------------------------------------------------------------- */
  var MAG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
            '<circle cx="11" cy="11" r="7"></circle><path d="M20 20l-4.3-4.3"></path></svg>';

  function enhanceHeader() {
    var header = document.getElementById('shopify-section-header');
    if (!header) return;

    header.querySelectorAll('.search_form, .header_search_form').forEach(function (form) {
      var input = form.querySelector('input[name="q"]');
      if (input && !input.getAttribute('aria-label')) {
        input.setAttribute('aria-label', bvnG('search_aria', 'Rechercher un accessoire, une marque ou un modele'));
      }
      var span = form.querySelector('span.search-submit');
      if (span) {
        var btn = document.createElement('button');
        btn.type = 'button';                 // la delegation jQuery du theme
        btn.className = 'search-submit';     // ecoute deja ".search-submit"
        btn.setAttribute('aria-label', bvnG('search_go', 'Lancer la recherche'));
        btn.innerHTML = MAG;
        span.parentNode.replaceChild(btn, span);
      }
    });

    header.querySelectorAll('a.bv-icon-link').forEach(function (a) {
      var href = a.getAttribute('href') || '';
      var label;
      if (href.indexOf('/cart') === 0) {
        var c = a.querySelector('.cart_count');
        var n = c ? (parseInt(c.textContent, 10) || 0) : 0;
        label = n === 1 ? bvnG('cart_one', 'Panier ({n} article)', { n: n }) : bvnG('cart_many', 'Panier ({n} articles)', { n: n });
      } else {
        label = bvnG('account', 'Mon compte');
      }
      if (a.getAttribute('aria-label') !== label) a.setAttribute('aria-label', label);
    });

    header.querySelectorAll('.top_bar--right > a.icon-search, .search_link > a.icon-search').forEach(function (a) {
      if (!a.getAttribute('aria-label')) a.setAttribute('aria-label', bvnG('open_search', 'Ouvrir la recherche'));
    });
  }

  /* ----------------------------------------------------------------------
     3. PASTILLE PANIER
     ---------------------------------------------------------------------- */
  function syncCartBadges() {
    document.querySelectorAll('.bv-icon-link .cart_count').forEach(function (el) {
      var v = (el.textContent || '').trim();
      var empty = v === '' || v === '0';
      if (empty !== el.classList.contains('bvx-empty')) {
        el.classList.toggle('bvx-empty', empty);
      }
    });
  }

  /* ----------------------------------------------------------------------
     4. BADGE D'ECONOMIE SUR LA PAGE PRODUIT
     ---------------------------------------------------------------------- */
  function parseMoney(txt) {
    if (!txt) return NaN;
    var s = String(txt).replace(/[^\d.,]/g, '').trim();
    if (!s) return NaN;
    var lastComma = s.lastIndexOf(',');
    var lastDot = s.lastIndexOf('.');
    if (lastComma > lastDot) s = s.replace(/\./g, '').replace(',', '.');
    else s = s.replace(/,/g, '');
    var n = parseFloat(s);
    return isNaN(n) ? NaN : n;
  }

  /* BVN : textes traduits (window.BVN_G, rendu hors français) et montant dans la devise du visiteur ; en français et en euros, inchangé. */
  function bvnG(k, d, o) { var g = window.BVN_G || {}; var s = g[k] || d; return o ? String(s).replace(/\{(\w+)\}/g, function (m, x) { return x in o ? o[x] : m; }) : s; }
  function fmtEuro(n) {
    var c = window.Shopify && Shopify.currency;
    if (c && c.active && c.active !== 'EUR') {
      try { var f = document.body.getAttribute('data-money-format'); if (f && Shopify.formatMoney) { var s = String(Shopify.formatMoney(Math.round(n * 100), f)).replace(/<[^>]+>/g, ''); if (/\d/.test(s)) return s; } } catch (e) {}
    }
    return n.toFixed(2).replace('.', ',') + ' €';
  }

  function updateProductSaveBadge() {
    var box = document.querySelector('.modal_price.bv-product-price');
    if (!box) return;
    var nowEl = box.querySelector('.current_price .money') || box.querySelector('.current_price');
    var wasEl = box.querySelector('.was_price .money') || box.querySelector('.was_price');
    var badge = box.querySelector('.bvx-savebadge');
    var now = nowEl ? parseMoney(nowEl.textContent) : NaN;
    var was = wasEl ? parseMoney(wasEl.textContent) : NaN;

    if (!isNaN(now) && !isNaN(was) && was > now) {
      var pct = Math.round(((was - now) / was) * 100);
      if (pct < 1) { if (badge) badge.remove(); return; }
      var sig = pct + '|' + (was - now).toFixed(2);
      // On ne reecrit QUE si la valeur a change : sinon l'observateur de
      // mutations se declencherait en boucle.
      if (badge && badge.dataset.sig === sig) return;
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'bvx-savebadge';
        (box.querySelector('.price__container') || box).appendChild(badge);
      }
      badge.dataset.sig = sig;
      badge.textContent = '';
      var b = document.createElement('b');
      b.textContent = '−' + pct + '%';
      var s = document.createElement('span');
      s.textContent = bvnG('save_abs', 'soit {x} d’économie', { x: fmtEuro(was - now) });
      badge.appendChild(b);
      badge.appendChild(s);
      badge.setAttribute('aria-label', bvnG('save_aria', 'Remise de {p} pour cent, soit {x} d’economie', { p: pct, x: fmtEuro(was - now) }));
    } else if (badge) {
      badge.remove();
    }
  }

  /* ----------------------------------------------------------------------
     BOOT
     ---------------------------------------------------------------------- */
  function boot() {
    initAllSliders(document);
    enhanceHeader();
    syncCartBadges();
    updateProductSaveBadge();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', boot);

  // Le theme remplace des blocs entiers (InstantClick, mini-panier AJAX,
  // changement de variante) : on rejoue les initialisations, en debounce.
  if ('MutationObserver' in window) {
    var t = null;
    new MutationObserver(function () {
      if (t) clearTimeout(t);
      t = setTimeout(boot, 200);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
